/*** IMPORTS FROM imports-loader ***/
var define = false;

/**
 * ########################################
 * Init Slick Slider
 * ########################################
 */
$('.slider-images').slick({
    infinite: true,
    slidesToShow: 3.5,
    slidesToScroll: 1,
    centerMode: true,
    arrows: true,
    dots: false,
    prevArrow:"<i class='fa fa-angle-left slick-prev'></i>",
    nextArrow:"<i class='fa fa-angle-right slick-next'></i>",
    responsive: [
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 2.5,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 567,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});

